<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="showModal"
      class="orangehrm-googlemap-dialog orangehrm-dialog-popup"
      @update:show="onCancel"
    >
      <div class="orangehrm-modal-header">
        <oxd-text type="card-title">{{ title }}</oxd-text>
      </div>
      <div class="orangehrm-text-center-align">
        <oxd-text
          class="sub-title"
          type="card-body"
          v-for="(stitle, i) in subtitle"
          :key="i"
        >
          {{ stitle }} <br />
        </oxd-text>
      </div>

      <template v-if="weekItems && weekItems.length > 0">
        <oxd-divider />
        <oxd-grid class="orangehrm-dropdown-container">
          <oxd-input-field
            v-model="selectedWeek"
            type="select"
            required
            :label="日期"
            :options="weekItems"
          />
        </oxd-grid>
      </template>

      <div class="orangehrm-modal-footer">
        <oxd-button
          label="取消"
          :display-type="cancelButtonType"
          class="orangehrm-button-margin"
          @click="onCancel"
        />
        <oxd-button
          :icon-name="icon"
          label="確定"
          :display-type="confirmButtonType"
          class="orangehrm-button-margin"
          @click="onConfirm"
        />
      </div>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';
import {ref} from 'vue';
import dayjs from 'dayjs';

export default {
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    initItems: {
      type: Array,
      required: true,
    },
    initTitle: {
      type: String,
      required: true,
    },
    initSubtitle: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      title: this.initTitle,
      subtitle: this.initSubtitle,
      weekItems: this.generateRecentWeeks(),
      selectedWeek: null, // 用於存儲選中的星期
      resolve: null,
      reject: null,
    };
  },
  methods: {
    generateRecentWeeks() {
      const weeks = [];
      for (let i = 1; i <= 10; i++) {
        const monday = dayjs()
          .subtract(i, 'week')
          .startOf('week')
          .add(1, 'day');
        weeks.push({
          id: monday.format('YYYY-MM-DD'),
          label: monday.format('YYYY-MM-DD'),
        });
      }
      return weeks;
    },
    onConfirm() {
      console.log('Selected week:', this.selectedWeek); // 確認時輸出選中的星期
      this.resolve && this.resolve({selectedWeek: this.selectedWeek});
      this.showModal = false;
    },
    onCancel() {
      this.resolve && this.resolve({selectedWeek: null});
      this.showModal = false;
    },
    showDialog() {
      return new Promise((resolve, reject) => {
        this.showModal = true;
        this.$nextTick(() => {
          this.title = ref(this.initTitle);
          this.subtitle = ref(this.initSubtitle);
          this.weekItems = ref(this.generateRecentWeeks());
          this.resolve = ref(resolve);
          this.reject = ref(reject);
        });
      });
    },
  },
};
</script>

<style src="./dialog.scss" lang="scss" scoped></style>
<style type="text/css">
.orangehrm-dropdown-container {
  max-width: 400px;
  margin: auto !important;
}

oxd-select {
  width: 100%;
  margin-top: 15px;
}
.oxd-text.sub-title {
  color: red;
}
</style>
